import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import SiteImg1 from '../../assest/Site-1.png';
import SiteImg2 from '../../assest/Site-2.png';
import SiteImg3 from '../../assest/Site-3.png';

const siteTransferList = [
  {
    name: "Standard Site Transport",
    image: SiteImg1,
    specs: "For routine inter-site material transfers.",
    description: "Efficient and reliable transport of supplies and small equipment between job sites.",
  },
  {
    name: "Heavy Equipment Relocation",
    image: SiteImg2,
    specs: "Moving large machinery between project sites.",
    description: "Safe and coordinated hauling of construction machines like excavators or cranes.",
  },
  {
    name: "Urgent Delivery Service",
    image: SiteImg3,
    specs: "Fast transfer of critical tools or parts.",
    description: "Priority handling for high-urgency material transfers between locations.",
  },
];

const translations = {
  gb: {
    heading: "Site-to-Site Transport",
    introText: "Seamless and efficient transportation between your construction sites.",
    categoriesTitle: "Available Transfer Options",
    featuredTitle: "Top Site-to-Site Services",
    featuredDescription: "Specialized services designed for safe and timely delivery across project locations.",
  },
  sa: {
    heading: "النقل بين المواقع",
    introText: "نقل سلس وفعال بين مواقع البناء الخاصة بك.",
    categoriesTitle: "خيارات النقل المتاحة",
    featuredTitle: "أفضل خدمات النقل بين المواقع",
    featuredDescription: "خدمات متخصصة مصممة لضمان تسليم آمن وفي الوقت المحدد بين مواقع المشاريع.",
  },
};

const SiteToSite = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={siteTransferList}
      language={language}
    />
  );
};

export default SiteToSite;
